// Al llegar al final de la página de producto, espera 3 segundos sin
// movimiento y sube sola a la zona de compra. Si el cliente toca, desliza
// o usa el teclado durante la cuenta, se cancela y se vuelve a armar
// cuando suelta/deja de moverse. Pensado para celulares reales: zona de
// "final" amplia (la barra del navegador y el rebote mueven unos píxeles),
// revisión por temporizador (no solo por eventos de scroll) y animación
// propia (no depende de scrollTo suave, que algunos celulares no soportan).
(function () {
  var ESPERA_MS = 3000;
  var ZONA_FINAL = 160;   // px desde el fondo que cuentan como "final"
  var ZONA_SALIDA = 600;  // al alejarse más de esto, se vuelve a armar
  var temporizador = null;
  var disparado = false;
  var tocando = false;
  var aviso = null;
  var animando = false;

  function altoDoc() {
    var d = document.documentElement, b = document.body;
    return Math.max(d.scrollHeight, b ? b.scrollHeight : 0);
  }
  function posY() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }
  function distanciaAlFinal() {
    return altoDoc() - (posY() + window.innerHeight);
  }
  function paginaLarga() {
    return altoDoc() > window.innerHeight * 2;
  }
  function objetivo() {
    return document.querySelector('.product__info-container') || document.querySelector('.product');
  }

  function mostrarAviso() {
    if (!aviso) {
      aviso = document.createElement('div');
      aviso.className = 'tz-volver-aviso';
      aviso.setAttribute('role', 'status');
      aviso.textContent = '↑ Volviendo a la compra…';
      document.body.appendChild(aviso);
    }
    setTimeout(function () { if (aviso && temporizador) aviso.classList.add('is-visible'); }, 20);
  }
  function ocultarAviso() {
    if (aviso) aviso.classList.remove('is-visible');
  }
  function cancelar() {
    if (temporizador) { clearTimeout(temporizador); temporizador = null; }
    ocultarAviso();
  }

  function animarHasta(destino) {
    var inicio = posY();
    var delta = destino - inicio;
    if (Math.abs(delta) < 2) return;
    var reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducir || !window.requestAnimationFrame) {
      window.scrollTo(0, destino);
      return;
    }
    var dur = Math.min(900, 350 + Math.abs(delta) * 0.08);
    var t0 = null;
    animando = true;
    function paso(t) {
      if (t0 === null) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      window.scrollTo(0, inicio + delta * e);
      if (p < 1 && animando) window.requestAnimationFrame(paso);
      else animando = false;
    }
    window.requestAnimationFrame(paso);
  }

  function subir() {
    temporizador = null;
    ocultarAviso();
    if (tocando || distanciaAlFinal() > ZONA_FINAL + 40) return;
    var el = objetivo();
    if (!el) return;
    disparado = true;
    var header = document.querySelector('.tz-header');
    var desfase = (header ? header.offsetHeight : 0) + 12;
    var top = el.getBoundingClientRect().top + posY() - desfase;
    animarHasta(Math.max(top, 0));
  }

  function armar() {
    if (disparado || tocando || !paginaLarga()) return;
    if (distanciaAlFinal() > ZONA_FINAL) return;
    cancelar();
    mostrarAviso();
    temporizador = setTimeout(subir, ESPERA_MS);
  }

  function revisar() {
    if (animando) return;
    var d = distanciaAlFinal();
    if (d > ZONA_SALIDA) {
      disparado = false;
      cancelar();
      return;
    }
    if (d > ZONA_FINAL) {
      cancelar();
      return;
    }
    // Dentro de la zona final: arranca la cuenta de 3 s si no hay una en
    // curso (los eventos de scroll la reinician porque cancelan antes).
    if (!temporizador) armar();
  }

  window.addEventListener('scroll', function () {
    if (animando) return;
    if (distanciaAlFinal() <= ZONA_FINAL) cancelar();
    revisar();
  }, { passive: true });

  window.addEventListener('touchstart', function () { tocando = true; cancelar(); animando = false; }, { passive: true });
  window.addEventListener('touchend', function () { tocando = false; setTimeout(revisar, 50); }, { passive: true });
  window.addEventListener('touchcancel', function () { tocando = false; }, { passive: true });
  ['wheel', 'keydown', 'mousedown'].forEach(function (evento) {
    window.addEventListener(evento, function () { cancelar(); animando = false; }, { passive: true });
  });

  // Respaldo: algunos celulares no avisan bien al terminar el desplazamiento.
  setInterval(revisar, 500);
})();
